// extracted by mini-css-extract-plugin
export default {"batchFilterContent":"XxrOC8XJNFHGdMMKJ451QQ==","searchFormContainer":"_5Yn3WLBgNYEd+2IEv+r0eQ==","searchFormProductContainer":"hcKabzcKDYKU2xeUkTz+wA=="};